import { render, staticRenderFns } from "./MainLegacy.vue?vue&type=template&id=44a03256&scoped=true"
import script from "./MainLegacy.vue?vue&type=script&lang=js"
export * from "./MainLegacy.vue?vue&type=script&lang=js"
import style0 from "./MainLegacy.vue?vue&type=style&index=0&id=44a03256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a03256",
  null
  
)

export default component.exports